<button
  mat-icon-button
  @fadeIn
  class="scroll-to-bottom-btn show"
  *ngIf="visible"
  (click)="onScrollClick()"
  [attr.aria-label]="ariaLabel"
  [title]="title"
>
  <mat-icon>{{ icon }}</mat-icon>
</button>